// src/features/media/components/VideoActionsGroup.tsx

import { Group, Button } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconCode, IconScissors, IconDownload } from '@tabler/icons-react';
import { MediaStatusType } from '@lib2/model/media/MediaTypes';
import { MediaUtils } from '../MediaUtils';
import { usePlayers } from '@/features/players/usePlayers';
import { PublishModal } from './PublishModal';
import { ClipToolModal } from './ClipToolModal';
import type { VideoViewData } from '@/lib/types/Media';

interface VideoActionsGroupProps {
  video: VideoViewData;
}

export function VideoActionsGroup({ video }: VideoActionsGroupProps) {
  const [publishOpened, { open: openPublish, close: closePublish }] = useDisclosure();
  const [clipOpened, { open: openClip, close: closeClip }] = useDisclosure();
  const { defaultPlayerId } = usePlayers();

  const isReady = video.media.mediaStatusType === MediaStatusType.Ready;
  const downloadUrl = MediaUtils.getDownloadUrl(defaultPlayerId, video);

  return (
    <>
      <Group gap="sm">
        <Button
          variant="light"
          leftSection={<IconCode size={16} />}
          onClick={openPublish}
        >
          Publish
        </Button>

        <Button
          variant="light"
          leftSection={<IconScissors size={16} />}
          onClick={openClip}
          disabled={!isReady}
        >
          Clip
        </Button>

        <Button
          variant="light"
          leftSection={<IconDownload size={16} />}
          disabled={!isReady || !downloadUrl}
          component="a"
          href={downloadUrl ?? undefined}
          target="_blank"
          // No "noreferrer": the CDN /link/http download endpoint authorizes
          // dashboard-originated downloads by Referer (legacy anchors sent it).
          rel="noopener"
        >
          Download
        </Button>
      </Group>

      <PublishModal
        opened={publishOpened}
        onClose={closePublish}
        media={video}
      />

      <ClipToolModal
        opened={clipOpened}
        onClose={closeClip}
        video={video}
      />
    </>
  );
}
